/* eslint-disable no-empty */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-did-update-set-state */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { I18n } from 'react-redux-i18n';

import ProductsUtil from '../../app/utils/products';

import PriceComponent from '../price/Price';
import inputSize from '../../data/inputs';
import NumberHelper from '../../helpers/number';
import validator from '../../helpers/validators';
import SimpleSpin from '../loading/SimpleSpin';
import tagManager from '../../app/services/tagManager';

class HeaderCartItem extends React.PureComponent {
  constructor(props) {
    super(props);

    this.throttleTimeout = null;
    this.throttleTime = 1000;

    this.state = {
      amount: 1,
      multipleQuantity: 1,
    };
  }

  async componentDidMount() {
    // this.updateInterval = setTimeout(this.updatePromotionCoutdown, 1000);
    const { product = {} } = this.props;
    if (product) {
      this.setState({
        multipleQuantity: product.multipleQuantity,
        amount: product.quantity,
      });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.updateInterval);
  }

  componentDidUpdate = async (prevProps) => {
    const { product = {} } = this.props;
    const { multipleQuantity } = this.state;
    if (product) {
      if (product.multipleQuantity !== multipleQuantity) {
        this.setState({
          multipleQuantity: product.multipleQuantity,
          amount: product.quantity,
        });
      } else if (
        prevProps.product
        && prevProps.product.quantity !== product.quantity
      ) {
        this.setState({
          amount: product.quantity,
        });
      }
    }
  };

  /* updatePromotionCoutdown = async () => {
    const { product = {} } = this.props;
    if (product.price && !product.price.isContract && product.price.finalizedAt) {
      const promotionCoutdown = ProductsUtil.getPromotionCountdown(product.price);
      await this.setState({ promotionCoutdown });
      this.updateInterval = setTimeout(this.updatePromotionCoutdown, 1000);
    }
  } */

  onClickViewProduct = (e) => {
    e.stopPropagation();

    const {
      clickPosition = 0,
      product,
      closeCartMenu = () => false,
    } = this.props;

    try {
      const productsToSend = [];
      const productsPromotionToSend = [];

      productsToSend.push({
        name: product.name,
        id: product.code,
        price: `${product.price ? product.price.value || 0 : 0}`,
        brand: product.brand ? product.brand.description : '',
        category: product.category ? product.category.name : '',
        list: I18n.t('cartBags'),
        position: clickPosition + 1,
      });

      if (product.price && product.price.promo) {
        productsPromotionToSend.push({
          id: product.code,
          name: product.name,
          creative: I18n.t('cartBags'),
          position: clickPosition + 1,
        });
      }

      tagManager.ecommerceClick(productsToSend);
      tagManager.ecommercePromotionClick(productsPromotionToSend);
    } catch (err) {}

    closeCartMenu();
  };

  formatTotal = value => value
    && Number(value).toFixed(
      NumberHelper.countDecimals(this.state.multipleQuantity),
    );

  handleAmount = async (value) => {
    const { amount } = this.state;
    const { offHandlers } = this.props;

    if (offHandlers) return;

    const valDecCount = (amount.toString().split('.')[1] || '').length;
    const stepDecCount = (value.toString().split('.')[1] || '').length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    let valInt = parseInt(Number(amount).toFixed(decCount).replace('.', ''), 0);
    valInt = valInt <= 0 ? valInt * -1 : valInt;
    const stepInt = parseInt(
      Number(value).toFixed(decCount).replace('.', ''),
      0,
    );
    const qtd = (valInt + stepInt) / 10 ** decCount;

    await this.handleSetAmount(qtd, false);
  };

  handleSetAmount = async (value, checkDecimals = true) => {
    const {
      product, allowSellSpotItensWithoutStock, item, type,
    } = this.props;

    if (
      value === ''
      || value === '0'
      || (typeof value === 'number' && value <= 0)
    ) {
      this.handleSetAmount(this.state.multipleQuantity || 1);
    } else if (!isNaN(value)) {
      const countedDecimals = NumberHelper.countDecimals(
        this.state.multipleQuantity,
      );
      if (countedDecimals > 0 && checkDecimals) {
        value = Number(value.toString().replace(/\D+/g, '')) / 10 ** countedDecimals;
      }
      value = value < 0 ? 0 : value;
      if (product.stock && value > product.stock) value = product.stock;
      if (value % 1 === 0 && countedDecimals === 0) {
        const modValue = value % product.multipleQuantity;
        if (modValue !== 0) value -= modValue;
      }
      if (value !== this.state.amount) {
        if (!this.props.isAuthenticated) {
          this.props.addItemCache(item.product.id, value - this.state.amount);
        } else {
          await this.setState({ amount: value });

          clearTimeout(this.throttleTimeout);
          this.throttleTimeout = setTimeout(async () => {
            if (type === 'favorite') await this.props.updateProductsFavorites(item.id, value);
            else await this.props.updateProductToCart(value, '', item, allowSellSpotItensWithoutStock);
          }, this.throttleTime);
        }
      }
    }

    if (
      validator.isSpotProductAmountInvalid(
        value,
        product.stock,
        allowSellSpotItensWithoutStock,
        product.isSpot,
        product.price.isContract,
      )
    ) {
      if (value !== this.state.amount) {
        if (!this.props.isAuthenticated) {
          this.props.addItemCache(item.product.id, value - this.state.amount);
        } else {
          await this.setState({ amount: value });
          this.throttleTimeout = setTimeout(async () => {
            if (type === 'favorite') await this.props.updateProductsFavorites(item.id, value);
            else await this.props.updateProductToCart(value, '', item, allowSellSpotItensWithoutStock);
          }, this.throttleTime);
        }
      }
    }
  };

  floatSafeModulus = (val, step) => {
    if (val && val !== '0') {
      const valDecCount = (val.toString().split('.')[1] || '').length;
      const stepDecCount = (step.toString().split('.')[1] || '').length;
      const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
      const valInt = parseInt(
        Number(val).toFixed(decCount).replace('.', ''),
        0,
      );
      const stepInt = parseInt(
        Number(step).toFixed(decCount).replace('.', ''),
        0,
      );
      return (((valInt % stepInt) + stepInt) % stepInt) / 10 ** decCount;
    }
    return 1;
  };

  render() {
    const { amount, multipleQuantity } = this.state;
    const {
      isAuthenticated,
      item,
      product = {},
      removeItem,
      removeItemCache,
      offHandlers,
      type,
      removeItemFavorite,
      addProductToCart,
    } = this.props;

    // const isContract = (product.price && product.price.isContract && product.price.type === 'contract');
    // const isAgreement = (product.price && product.price.isContract && product.price.type === 'agreement');
    // const isDiscount = (product.price && !product.price.isContract && product.price.discount);
    // const isWithoutStock = (product.isSpot && !product.price.isContract && !allowSellSpotItensWithoutStock && product.stock === 0);
    // const isContactUs = (!product.stock && product.price && product.price.contactUs);
    // const showAddToCart = ((isAuthenticated && cartPermission && product.price && product.price.hasPrice) || (!isAuthenticated))
    // && (!isContactUs && !isWithoutStock);
    // const showOldValue = (pricePermission && product.price && !product.price.isContract && product.price.oldValue);

    return (
      <React.Fragment>
        {type === 'favorite' ? (
          <React.Fragment>
            <div className="favorite">
              <div className="item">
                <Link
                  to={ProductsUtil.getUrl({
                    id: product.soneparId,
                    clientCode: item.productClientCode,
                  })}
                  onClick={this.onClickViewProduct}
                >
                  {product.image && (
                    <span
                      className="image"
                      style={{
                        backgroundImage: `url(${
                          product.image
                          || '/images/product-image-placeholder.png'
                        })`,
                      }}
                    />
                  )}
                </Link>

                <Link
                  className="description"
                  to={ProductsUtil.getUrl({
                    id: product.soneparId,
                    clientCode: item.productClientCode,
                  })}
                  style={{ textDecoration: 'none' }}
                  // onClick={closeCartMenu}
                >
                  {`${product.description.slice(0, 20)}...`}
                  <span className="small">
                    {product.clientCode || product.code}
                  </span>

                  {item && item.contractId && (
                    <div>
                      <span className="name">
                        {`${I18n.t('contract')}: ${item.contractId}`}
                      </span>
                    </div>
                  )}
                </Link>
                <div>
                  <a
                    style={{ cursor: 'pointer' }}
                    className="remove"
                    onClick={() => removeItemFavorite(item.id, item.clientId)}
                  >
                    {I18n.t('remove')}
                  </a>
                  <br />
                  {product.pricing && (
                    <div className="box__l">
                      <span className="price">
                        <PriceComponent
                          value={(product.pricing && product.pricing.pricingByQuantity)
                            ? product.pricing.pricingByQuantity + (product.pricing.icmsST || 0) : 0}
                        />
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="option-favorite-menu p-footer">
              <div className="add-more custom-add">
                <div className="less">
                  <button
                    className="add__less"
                    type="button"
                    onClick={() => this.handleAmount(-multipleQuantity)}
                  >
                    -
                  </button>
                </div>
                <div className="qnt" style={{ minWidth: '39px' }}>
                  <input
                    className="add__qnt"
                    type="tel"
                    value={this.formatTotal(amount) || '0'}
                    onChange={e => this.modifyQuantityOfProducts(e.target.value)
                    }
                  />
                </div>
                <div className="more">
                  <button
                    className="add__more custom-add"
                    type="button"
                    onClick={() => this.handleAmount(+multipleQuantity)}
                  >
                    +
                  </button>
                </div>
              </div>

              <span
                onClick={() => addProductToCart(
                  product.soneparId,
                  product.clientCode,
                  amount,
                )
                }
                className="add-to-cart-favorite"
              >
                {I18n.t('addToCart')}
              </span>
            </div>
          </React.Fragment>
        ) : (
          <div className="item">
            <Link
              to={ProductsUtil.getUrl(product)}
              onClick={this.onClickViewProduct}
            >
              <span
                className="image"
                style={{
                  backgroundImage: `url(${
                    product.image || '/images/product-image-placeholder.png'
                  })`,
                }}
              />
            </Link>
            <div className="box">
              <div className="box__l">
                <Link
                  to={ProductsUtil.getUrl(product)}
                  onClick={this.onClickViewProduct}
                  style={{ textDecoration: 'none' }}
                >
                  <span className="name">{product.name}</span>
                </Link>
                <a
                  style={{ cursor: 'pointer' }}
                  className="remove"
                  onClick={() => (isAuthenticated
                    ? removeItem(product.id, product.clientCode)
                    : removeItemCache(product.id))
                  }
                >
                  {I18n.t('remove')}
                </a>
              </div>
              {product && product.contractId && (
                <div className="box__l" style={{ margin: '10px 0px 2px 0px' }}>
                  <span className="name">
                    {`${I18n.t('contract')}: ${product.contractId}`}
                  </span>
                </div>
              )}
              <div className="box__l">
                <div className="add">
                  <button
                    className="add__less"
                    type="button"
                    onClick={() => this.handleAmount(-multipleQuantity)}
                  >
                    -
                  </button>
                  <input
                    className="add__qnt"
                    type="text"
                    maxLength={inputSize.maxDefault}
                    value={this.formatTotal(amount) || '0'}
                    onChange={e => this.handleSetAmount(e.target.value)}
                  />
                  <button
                    className="add__more"
                    type="button"
                    onClick={() => this.handleAmount(+multipleQuantity)}
                  >
                    +
                  </button>
                </div>
                <span className="price">
                  {offHandlers ? (
                    <SimpleSpin isItem />
                  ) : (
                    <PriceComponent
                      value={
                        item.total * item.product.price.value
                        + (item.product.price.icmsST || 0)
                      }
                    />
                  )}
                </span>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.authenticated,
  cartPermission:
    state.contracts.selected && state.contracts.selected.cartPermission,
  pricePermission:
    state.contracts.selected && state.contracts.selected.pricePermission,
  stockPermission:
    !state.contracts.selected
    || (state.contracts.selected && state.contracts.selected.stockPermission),
  allowSellSpotItensWithoutStock:
    state.contracts.selected
    && state.contracts.selected.clientDetails.allowSellSpotItensWithoutStock,
  punchOut: state.punchOut,
});

export default connect(mapStateToProps, {})(HeaderCartItem);
